import { TextField } from "@mui/material";
import { Alert, Button, Form } from "antd";
import { ReactNode } from "react";
import { Link } from "react-router";
import { RoutePaths } from "../../../views/routes";
import Password from "../../Components/Password";

export interface RegisterModel {
  email: string;
  password: string;
  username: string;
}

interface RegistrationFormProps {
  onFinish: (data: RegisterModel) => void;
  formError: string | ReactNode | undefined;
}

export default function RegistrationForm({
  onFinish,
  formError,
}: RegistrationFormProps) {
  const [form] = Form.useForm();

  return (
    <Form
      form={form}
      name="register"
      onFinish={onFinish}
      style={{ maxWidth: 600 }}
      scrollToFirstError
    >
      {formError !== undefined && (
        <Alert
          message={formError}
          type="error"
          showIcon
          style={{ marginBottom: "20px" }}
        />
      )}

      <Form.Item
        name="username"
        tooltip="What do you want others to call you?"
        rules={[
          {
            required: true,
            message: "Please input your username!",
            whitespace: true,
          },
        ]}
      >
        <TextField label="Name" variant="outlined" fullWidth />
      </Form.Item>

      <Form.Item
        name="email"
        rules={[
          {
            type: "email",
            message: "The input is not valid E-mail!",
          },
          {
            required: true,
            message: "Please input your E-mail!",
          },
        ]}
      >
        <TextField label="Email" variant="outlined" fullWidth />
      </Form.Item>

      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: "Please input your password!",
          },
        ]}
        hasFeedback
      >
        {/* @ts-expect-error ignoring lack of onChange value */}
        <Password />
      </Form.Item>

      <Form.Item
        name="confirm"
        dependencies={["password"]}
        hasFeedback
        rules={[
          {
            required: true,
            message: "Please confirm your password!",
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("password") === value) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("The two passwords that you entered do not match!"),
              );
            },
          }),
        ]}
      >
        {/* @ts-expect-error ignoring lack of onChange value */}
        <Password label="Repeat password" />
      </Form.Item>

      <Form.Item>
        <Button
          type="primary"
          shape="round"
          size="large"
          block
          htmlType="submit"
        >
          Sign up
        </Button>
      </Form.Item>

      <span>
        By signing up you agree to Wishlist&nbsp;
        <Link to={RoutePaths.termsOfUse} viewTransition>
          Terms of Use
        </Link>{" "}
        and{" "}
        <Link to={RoutePaths.privacyPolicy} viewTransition>
          Privacy Policy
        </Link>
      </span>
    </Form>
  );
}
